import React from "react";
import { useHistory } from "react-router-dom";
import { MenuOutlined } from "@mui/icons-material";
import trade_text from "../../../assets/images/trade_text_transparent.png";

const getAdminInfo = () => {
  try {
    const token = localStorage.getItem("adminToken");
    if (!token) return { name: "Admin", initial: "A" };
    const d = JSON.parse(atob(token.split(".")[1]));
    const name = d.firstName
      ? `${d.firstName} ${d.lastName || ""}`.trim()
      : d.name || d.email || "Admin";
    return { name, initial: name[0].toUpperCase() };
  } catch {
    return { name: "Admin", initial: "A" };
  }
};

const AdminHeader = ({ onMenuClick }) => {
  const history = useHistory();
  const { name, initial } = getAdminInfo();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    history.push("/admin/login");
  };

  return (
    <header className="admin-header">
      <div className="admin-header-left">
        <button
          className="admin-header-menu-btn"
          onClick={onMenuClick}
          type="button"
          aria-label="Toggle menu"
        >
          <MenuOutlined style={{ fontSize: 20 }} />
        </button>
        <img src={trade_text} alt="TradeitFwd" className="admin-header-logo" />
      </div>
      <div className="admin-header-right">
        <div className="admin-header-user">
          <div className="admin-header-avatar">{initial}</div>
          <span className="admin-header-name">{name}</span>
        </div>
        <button className="admin-header-logout" onClick={handleLogout} type="button">
          Logout
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
